import React, {useContext, useState} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import Select, {Props} from 'react-select';
import { FormContext } from '../metadata/MDForm';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';
import {Attribute, AttributeCondition} from "../metadata/api/attribute";
import { getOptionsForAttr } from './coderefs';
import InputNumber from 'antd/lib/input-number';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  const prevArray = previousValue.split('/');
  const formatted = mapAndFormat(prevArray);
  return `${formatMoneyAmountNoDecimal(formatted)}`;
};

export function ConditionalField({attr, optionsYes, optionsNo, dataType, ...props}) {

  const formContext = useContext(FormContext);
  const { setValueByAttr, getValueByAttr } = formContext;

  let applicationModel = useContext(ModelContext);
  let line = applicationModel.getValue(`lines{lineCd:CollectorVehicle}`);
  
  let attribute = formContext.metadata[attr];

  const actions = useContext(ApplicationActionsContext);
  let ariaLabel = attribute.label;

  let flag = false;
  if (props.dependentAttr != undefined && props.dependentVal != undefined) {
    let dependentAttrVal = getValueByAttr(props.dependentAttr);
    if (dependentAttrVal === props.dependentVal) {
      flag = true;
    }
  }

  let customOptions = optionsYes;
  if(!flag){
    customOptions = optionsNo;
  }

  let selected = null;
  let children = customOptions.map(({value, name}) => <PortalSelectOption value={value}>
      {name}
    </PortalSelectOption>);
  const options = React.Children.map(children, el => {
      if (!el.props) {
        return null;
      }
      const obj = {
        label: el.props.children,
        value: el.props.value
      };
      if (el.props.value === props.value) {
        selected = obj;
      }
      return obj;
  });

  if(selected === null){
    selected = options[0];
    setValueByAttr(attr, selected.value);
  }

  const previousValue = selected;
  const [selectedValue, setSelectedValue] = useState(previousValue);

  const handleChange = (selected) => {
        setValueByAttr(attr, selected.value);
        setSelectedValue(selected);
        actions.saveApplication();
      };

  return <Select
          {...props}
          aria-label="Select"
          styles={customStylesUpdater}
          title="Select"
          openMenuOnFocus
          placeholder={null}
          options={options}
          value={selected}
          onChange={handleChange}
          components={{
            IndicatorSeparator: () => null,
          }}
          theme={(theme) => ({
            ...theme,
            borderRadius: 4,
            zIndex: 3,
            colors: {
              ...theme.colors,
              primary25: 'rgb(0, 115, 157, 0.1)',
              primary: 'rgba(0, 115, 157, 0.5)',
              neutral30: 'rgba(0, 115, 157, 0.5)',
            },
          })}
        />
}

const customStylesUpdater = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

ConditionalField.schema = BASIC_ELEMENT_SCHEMA;